const themes = [
  {
    id: 1,
    title: 'Convenant',
    slug: 'convenant',
    description: 'Een formele overeenkomst of afspraak tussen twee of meer partijen.',
    icon: 'file-contract',
  },
  {
    id: 2,
    title: 'Bestuursstuk',
    slug: 'bestuursstuk',
    description: 'Document dat wordt gebruikt om beleid of richtlijnen vast te leggen.',
    icon: 'file-lines',
  },
  {
    id: 3,
    title: 'WOO-verzoek',
    slug: 'woo-verzoek',
    description: 'Verzoek bij een overheidsinstantie om informatie op te vragen.',
    icon: 'file-circle-question',
  },
  {
    id: 4,
    title: 'Organisatie en werkwijze',
    slug: 'organisatie-en-werkwijze',
    description: 'Lees en beantwoording van de gemeente Den Haag op een informatieverzoek.',
    icon: 'building-user',
  },
  {
    id: 5,
    title: 'Bereikbaarheidsgegevens',
    slug: 'bereikbaarheidsgegevens',
    description: 'De bereikbaarheid van Gemeente Den Haag voor het indienen van een informatieverzoek.',
    icon: 'location-dot',
  },
  {
    id: 6,
    title: 'Raadsstuk',
    slug: 'raadsstuk',
    description: 'Documenten die worden besproken tijdens de gemeenteraadsvergadering.',
    icon: 'gavel',
  },
];

export default {
  getAll: () => Promise.resolve(themes),
  getBySlug: (slug) => Promise.resolve(themes.find((theme) => theme.slug === slug)),
  getById: (id) => Promise.resolve(themes.find((theme) => theme.id === id)),
};
